import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { categories } from '@/mocks/categories';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-20 flex items-center">
        <div className="mx-auto max-w-content w-full px-4 md:px-8 py-20 md:py-28">
          <div className="max-w-2xl">
            <p className="font-heading text-7xl md:text-9xl font-black text-background-300 select-none">
              404
            </p>
            <h1 className="mt-4 font-heading text-2xl md:text-4xl font-black text-foreground-950">
              这条档案不在现场
            </h1>
            <p className="mt-4 text-sm md:text-base text-foreground-600">
              你访问的路径
              <code className="mx-1.5 px-2 py-0.5 rounded bg-background-100 border border-background-200 text-xs text-foreground-700 font-mono">
                {location.pathname}
              </code>
              暂时没有对应内容，可能已被合并或链接已更新。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md text-sm font-label transition-colors whitespace-nowrap"
              >
                <i className="ri-home-4-line text-base leading-none" aria-hidden="true" />
                返回首页
              </Link>
              <Link
                to="/category/live"
                className="inline-flex items-center justify-center gap-2 border border-background-300 hover:border-primary-300 text-foreground-800 hover:text-primary-600 px-6 py-3 rounded-md text-sm font-label transition-colors whitespace-nowrap"
              >
                浏览反差档案
              </Link>
            </div>

            <div className="mt-12 pt-8 border-t border-background-200">
              <p className="text-xs text-foreground-500 font-label mb-4">或者从这些栏目开始</p>
              <div className="flex flex-wrap gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-3.5 py-2 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}